import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ClientDashboard = () => {
  const [dashboard, setDashboard] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [requests, setRequests] = useState([]);
  const [statement, setStatement] = useState(null);
  const [report, setReport] = useState(null);
  const [incomingTransfers, setIncomingTransfers] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [showPayToMainForm, setShowPayToMainForm] = useState(false);
  const [showDeliverModal, setShowDeliverModal] = useState(false);
  const [selectedTransfer, setSelectedTransfer] = useState(null);
  const [deliverCode, setDeliverCode] = useState('');
  const [searchCode, setSearchCode] = useState('');
  const [foundTransfer, setFoundTransfer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [filterCurrency, setFilterCurrency] = useState('all');
  const [reportPeriod, setReportPeriod] = useState('daily');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [form, setForm] = useState({
    to_customer_id: '', amount: '', currency_code: 'USD', type: 'transfer', notes: ''
  });
  const [payToMainForm, setPayToMainForm] = useState({
    amount: '', currency_code: 'USD', notes: ''
  });
  const token = localStorage.getItem('client_token');
  const clientInfo = JSON.parse(localStorage.getItem('client_info') || '{}');
  const currencyList = ['IQD', 'USD', 'EUR', 'GBP', 'SAR', 'AED', 'TRY', 'CAD'];

  useEffect(() => {
    fetchDashboard();
    fetchCustomers();
    fetchRequests();
    fetchIncomingTransfers();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/client/dashboard', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDashboard(res.data);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem('client_token');
        localStorage.removeItem('client_info');
        window.location.href = '/client/login';
      }
    }
  };

  const fetchCustomers = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/client/customers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(res.data.customers);
    } catch (err) { console.error(err); }
  };

  const fetchRequests = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/client/requests', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRequests(res.data.requests);
    } catch (err) { console.error(err); }
  };

  const fetchIncomingTransfers = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/transfers/client/list', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIncomingTransfers(res.data.transfers || []);
    } catch (err) { console.error(err); }
  };

  const fetchStatement = async () => {
    try {
      let url = 'https://app.hayahost.net/api/client/statement';
      if (filterCurrency !== 'all') url += `?currency=${filterCurrency}`;
      const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setStatement(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchReport = async () => {
    try {
      let url = `https://app.hayahost.net/api/client/report?period=${reportPeriod}`;
      if (reportPeriod === 'custom') url = `https://app.hayahost.net/api/client/report?from_date=${fromDate}&to_date=${toDate}`;
      const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setReport(res.data);
    } catch (err) { console.error(err); }
  };

  const downloadPDF = async () => {
    setLoadingPDF(true);
    try {
      let url = `https://app.hayahost.net/api/client/report-pdf?period=${reportPeriod}`;
      if (reportPeriod === 'custom') url = `https://app.hayahost.net/api/client/report-pdf?from_date=${fromDate}&to_date=${toDate}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const urlObj = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlObj;
      link.setAttribute('download', `client_report.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) { alert('خطأ في تحميل PDF'); }
    setLoadingPDF(false);
  };

  const handleRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/client/request', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('تم إرسال الطلب بنجاح! بانتظار مطابقة الرئيسي');
      setShowRequestForm(false);
      setForm({ to_customer_id: '', amount: '', currency_code: 'USD', type: 'transfer', notes: '' });
      fetchDashboard();
      fetchRequests();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في إرسال الطلب');
    }
    setLoading(false);
  };

  const handlePayToMain = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/client/pay-to-main', payToMainForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('تم إرسال طلب التسديد للرئيسي! بانتظار المطابقة');
      setShowPayToMainForm(false);
      setPayToMainForm({ amount: '', currency_code: 'USD', notes: '' });
      fetchDashboard();
      fetchRequests();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في إرسال الطلب');
    }
    setLoading(false);
  };

  const searchTransfer = async () => {
    if (!searchCode) return alert('أدخل الكود السري');
    try {
      const res = await axios.get(`https://app.hayahost.net/api/transfers/client/find/${searchCode}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFoundTransfer(res.data.transfer);
    } catch (err) {
      alert(err.response?.data?.message || 'الكود غير صحيح أو الحوالة غير موجودة');
      setFoundTransfer(null);
    }
  };

  const deliverTransfer = async () => {
    if (!foundTransfer) return;
    setLoading(true);
    try {
      await axios.put(
        `https://app.hayahost.net/api/transfers/client/deliver/${foundTransfer.id}`,
        { secret_code: searchCode, notes: `تسليم بواسطة ${clientInfo.customer_name}` },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('تم تسليم الحوالة بنجاح! 🎉');
      setFoundTransfer(null);
      setSearchCode('');
      fetchDashboard();
      fetchIncomingTransfers();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في تسليم الحوالة');
    }
    setLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('client_token');
    localStorage.removeItem('client_info');
    window.location.href = '/client/login';
  };

  const handlePrint = () => { window.print(); };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  const getStatusBadge = (status) => {
    switch(status) {
      case 'pending': return { text: '⏳ بانتظار المطابقة', bg: '#fff3e0', color: '#e65100' };
      case 'approved': return { text: '✅ تمت المطابقة', bg: '#e8f5e9', color: '#2e7d32' };
      case 'rejected': return { text: '❌ مرفوض', bg: '#ffebee', color: '#c62828' };
      default: return { text: status, bg: '#f5f5f5', color: '#666' };
    }
  };

  const getTypeLabel = (type) => {
    const types = {
      'receive': '📥 استلام', 'pay': '📤 دفع', 'buy': '🛒 شراء',
      'sell': '💰 بيع', 'transfer_in': '💸 تحويل وارد',
      'transfer_out': '💸 تحويل صادر', 'commission': '💹 عمولة'
    };
    return types[type] || type;
  };

  const summaryByCurrency = report?.summary?.reduce((acc, s) => {
    if (!acc[s.currency_code]) acc[s.currency_code] = {};
    acc[s.currency_code][s.type] = parseFloat(s.total);
    return acc;
  }, {}) || {};

  const pendingTransfers = incomingTransfers.filter(t => t.status === 'pending').length;

  if (!dashboard) return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh'}}>
      <div style={{color: '#1a237e', fontSize: '18px'}}>⏳ جاري التحميل...</div>
    </div>
  );

  return (
    <div style={styles.container}>
      <style>{`@media print { .no-print { display: none !important; } body { direction: rtl; } }`}</style>

      <div style={styles.navbar} className="no-print">
        <h1 style={styles.navTitle}>🏦 بوابة العملاء</h1>
        <div style={styles.navInfo}>
          <span style={styles.navUser}>
            {clientInfo.customer_type === 'company' ? '🏢' : '👤'} {clientInfo.customer_name}
          </span>
          <button style={styles.printBtn} onClick={handlePrint}>🖨️ طباعة</button>
          <button style={styles.logoutBtn} onClick={handleLogout}>خروج</button>
        </div>
      </div>

      <div style={styles.content}>
        {/* تبويبات */}
        <div style={styles.tabs} className="no-print">
          {[
            { key: 'dashboard', label: '🏠 الرئيسية' },
            { key: 'transfers', label: `💸 الحوالات الواردة ${pendingTransfers > 0 ? `(${pendingTransfers})` : ''}` },
            { key: 'requests', label: '📋 طلباتي' },
            { key: 'statement', label: '📒 كشف الحساب' },
            { key: 'reports', label: '📊 التقارير' },
          ].map(tab => (
            <button key={tab.key}
              style={activeTab === tab.key ? styles.tabActive : styles.tabBtn}
              onClick={() => {
                setActiveTab(tab.key);
                if (tab.key === 'statement') fetchStatement();
              }}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* لوحة التحكم */}
        {activeTab === 'dashboard' && (
          <>
            <div style={styles.section}>
              <h2 style={styles.sectionTitle}>💳 أرصدتي</h2>
              <div style={styles.balanceGrid}>
                {dashboard.accounts.length > 0 ? dashboard.accounts.map((a, i) => (
                  <div key={i} style={styles.balanceCard}>
                    <div style={styles.balanceCurrency}>{a.currency_code}</div>
                    <div style={{...styles.balanceAmount, color: parseFloat(a.balance) >= 0 ? '#2e7d32' : '#c62828'}}>
                      {parseFloat(a.balance).toLocaleString()}
                    </div>
                    <div style={styles.balanceDetails}>
                      <span style={{color: '#2e7d32'}}>له: {parseFloat(a.total_credit).toLocaleString()}</span>
                      <span style={{color: '#c62828'}}>عليه: {parseFloat(a.total_debit).toLocaleString()}</span>
                    </div>
                  </div>
                )) : <div style={styles.noBalance}>لا يوجد رصيد حالياً</div>}
              </div>
            </div>

            {dashboard.debts.length > 0 && (
              <div style={styles.section}>
                <h2 style={styles.sectionTitle}>📋 المديونيات</h2>
                <div style={styles.debtGrid}>
                  {dashboard.debts.map((d, i) => (
                    <div key={i} style={styles.debtCard}>
                      <div style={styles.debtType}>{d.debt_type === 'receivable' ? '📥 مطلوب منك' : '📤 مطلوب لك'}</div>
                      <div style={styles.debtAmount}>
                        {parseFloat(d.remaining_amount || d.amount).toLocaleString()}
                        <span style={styles.debtCurrency}>{d.currency}</span>
                      </div>
                      {d.notes && <div style={styles.debtNotes}>{d.notes}</div>}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {dashboard.debt_summary && (
              <div style={styles.summaryCard}>
                <div style={styles.summaryItem}>
                  <span style={styles.summaryLabel}>📥 إجمالي مطلوب منك</span>
                  <span style={{...styles.summaryValue, color: '#c62828'}}>
                    {parseFloat(dashboard.debt_summary.total_receivable || 0).toLocaleString()}
                  </span>
                </div>
                <div style={styles.summaryItem}>
                  <span style={styles.summaryLabel}>📤 إجمالي مطلوب لك</span>
                  <span style={{...styles.summaryValue, color: '#2e7d32'}}>
                    {parseFloat(dashboard.debt_summary.total_payable || 0).toLocaleString()}
                  </span>
                </div>
              </div>
            )}

            <div style={styles.section}>
              <h2 style={styles.sectionTitle}>💸 العمليات</h2>
              <div style={styles.actionButtons} className="no-print">
                <button style={styles.transferBtn}
                  onClick={() => { setShowRequestForm(!showRequestForm); setShowPayToMainForm(false); }}>
                  {showRequestForm ? 'إلغاء' : '💸 تحويل لعميل/شركة'}
                </button>
                <button style={styles.payMainBtn}
                  onClick={() => { setShowPayToMainForm(!showPayToMainForm); setShowRequestForm(false); }}>
                  {showPayToMainForm ? 'إلغاء' : '🏦 تسديد للرئيسي'}
                </button>
              </div>

              {showRequestForm && (
                <div style={styles.formCard}>
                  <h3 style={styles.formTitle}>💸 طلب تحويل لعميل / شركة</h3>
                  <p style={styles.formNote}>⚠️ سيتم الخصم من رصيدك بعد موافقة الرئيسي</p>
                  <form onSubmit={handleRequest}>
                    <div style={styles.formGrid}>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>نوع الطلب</label>
                        <select style={styles.input} value={form.type} onChange={e => setForm({...form, type: e.target.value})}>
                          <option value="transfer">💸 تحويل</option>
                          <option value="payment">💰 تسديد</option>
                        </select>
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>إلى عميل / شركة</label>
                        <select style={styles.input} value={form.to_customer_id}
                          onChange={e => setForm({...form, to_customer_id: e.target.value})} required>
                          <option value="">-- اختر --</option>
                          {customers.map(c => (
                            <option key={c.id} value={c.id}>
                              {c.customer_type === 'company' ? '🏢' : '👤'} {c.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>المبلغ</label>
                        <input style={styles.input} type="number" value={form.amount}
                          onChange={e => setForm({...form, amount: e.target.value})} placeholder="0" required />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>العملة</label>
                        <select style={styles.input} value={form.currency_code}
                          onChange={e => setForm({...form, currency_code: e.target.value})}>
                          {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                      </div>
                      {form.currency_code && (
                        <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                          {dashboard.accounts.filter(a => a.currency_code === form.currency_code).map((a, i) => (
                            <div key={i} style={styles.availableBalance}>
                              💳 الرصيد المتاح: <strong style={{color: parseFloat(a.balance) > 0 ? '#2e7d32' : '#c62828'}}>{parseFloat(a.balance).toLocaleString()} {a.currency_code}</strong>
                            </div>
                          ))}
                        </div>
                      )}
                      <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                        <label style={styles.label}>ملاحظات</label>
                        <input style={styles.input} value={form.notes}
                          onChange={e => setForm({...form, notes: e.target.value})} placeholder="أي ملاحظات للرئيسي" />
                      </div>
                    </div>
                    <button style={styles.submitBtn} type="submit" disabled={loading}>
                      {loading ? 'جاري الإرسال...' : '📤 إرسال الطلب'}
                    </button>
                  </form>
                </div>
              )}

              {showPayToMainForm && (
                <div style={{...styles.formCard, borderRight: '4px solid #2e7d32'}}>
                  <h3 style={{...styles.formTitle, color: '#2e7d32'}}>🏦 تسديد للرئيسي مباشرة</h3>
                  <p style={styles.formNote}>⚠️ سيتم خصم المبلغ من رصيدك وتخفيض ديونك بعد موافقة الرئيسي</p>
                  <form onSubmit={handlePayToMain}>
                    <div style={styles.formGrid}>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>المبلغ</label>
                        <input style={styles.input} type="number" value={payToMainForm.amount}
                          onChange={e => setPayToMainForm({...payToMainForm, amount: e.target.value})} placeholder="0" required />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>العملة</label>
                        <select style={styles.input} value={payToMainForm.currency_code}
                          onChange={e => setPayToMainForm({...payToMainForm, currency_code: e.target.value})}>
                          {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                      </div>
                      {payToMainForm.currency_code && (
                        <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                          {dashboard.accounts.filter(a => a.currency_code === payToMainForm.currency_code).map((a, i) => (
                            <div key={i} style={styles.availableBalance}>
                              💳 الرصيد المتاح: <strong style={{color: parseFloat(a.balance) > 0 ? '#2e7d32' : '#c62828'}}>{parseFloat(a.balance).toLocaleString()} {a.currency_code}</strong>
                            </div>
                          ))}
                        </div>
                      )}
                      <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                        <label style={styles.label}>ملاحظات</label>
                        <input style={styles.input} value={payToMainForm.notes}
                          onChange={e => setPayToMainForm({...payToMainForm, notes: e.target.value})} placeholder="سبب التسديد" />
                      </div>
                    </div>
                    <button style={{...styles.submitBtn, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}} type="submit" disabled={loading}>
                      {loading ? 'جاري الإرسال...' : '🏦 إرسال طلب التسديد'}
                    </button>
                  </form>
                </div>
              )}
            </div>

            {dashboard.recent_requests.length > 0 && (
              <div style={styles.section}>
                <h2 style={styles.sectionTitle}>🕐 آخر الطلبات</h2>
                <div style={styles.tableCard}>
                  <table style={styles.table}>
                    <thead>
                      <tr style={styles.tableHead}>
                        <th style={styles.th}>الرقم المرجعي</th>
                        <th style={styles.th}>النوع</th>
                        <th style={styles.th}>إلى</th>
                        <th style={styles.th}>المبلغ</th>
                        <th style={styles.th}>الحالة</th>
                        <th style={styles.th}>التاريخ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboard.recent_requests.map((r, i) => {
                        const status = getStatusBadge(r.status);
                        return (
                          <tr key={r.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                            <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{r.reference_number}</td>
                            <td style={styles.td}>
                              {r.type === 'pay_to_main' ? <span style={{color: '#2e7d32', fontWeight: 'bold'}}>🏦 تسديد للرئيسي</span> : '💸 تحويل'}
                            </td>
                            <td style={styles.td}>{r.to_customer_name || 'الرئيسي'}</td>
                            <td style={{...styles.td, fontWeight: 'bold'}}>{parseFloat(r.amount).toLocaleString()} {r.currency_code}</td>
                            <td style={styles.td}>
                              <span style={{background: status.bg, color: status.color, padding: '3px 8px', borderRadius: '10px', fontSize: '11px'}}>
                                {status.text}
                              </span>
                            </td>
                            <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(r.created_at)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}

        {/* الحوالات الواردة */}
        {activeTab === 'transfers' && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>💸 الحوالات الواردة</h2>

            {/* البحث بالكود */}
            <div style={styles.searchTransferCard}>
              <h3 style={styles.searchTransferTitle}>🔐 تسليم حوالة بالكود السري</h3>
              <p style={{color: '#666', fontSize: '13px', marginBottom: '15px'}}>
                أدخل الكود السري الذي أعطاه الرئيسي للمستلم للتحقق وتسليم الحوالة
              </p>
              <div style={styles.searchTransferRow}>
                <input style={{...styles.input, flex: 1, letterSpacing: '3px', fontSize: '18px', textAlign: 'center'}}
                  value={searchCode}
                  onChange={e => setSearchCode(e.target.value.toUpperCase())}
                  placeholder="HW-XXXXXX"
                  maxLength={9} />
                <button style={styles.searchCodeBtn} onClick={searchTransfer}>
                  🔍 بحث
                </button>
              </div>

              {foundTransfer && (
                <div style={styles.foundTransferCard}>
                  <h4 style={{color: '#2e7d32', marginBottom: '15px'}}>✅ تم العثور على الحوالة</h4>
                  <div style={styles.foundTransferDetails}>
                    <div style={styles.foundRow}>
                      <span style={styles.foundLabel}>الرقم المرجعي</span>
                      <span style={styles.foundValue}>{foundTransfer.reference_number}</span>
                    </div>
                    <div style={styles.foundRow}>
                      <span style={styles.foundLabel}>اسم المستلم</span>
                      <span style={{...styles.foundValue, color: '#1a237e', fontSize: '16px', fontWeight: 'bold'}}>{foundTransfer.receiver_name}</span>
                    </div>
                    <div style={styles.foundRow}>
                      <span style={styles.foundLabel}>هاتف المستلم</span>
                      <span style={styles.foundValue}>{foundTransfer.receiver_phone}</span>
                    </div>
                    <div style={styles.foundRow}>
                      <span style={styles.foundLabel}>المبلغ</span>
                      <span style={{...styles.foundValue, color: '#2e7d32', fontSize: '22px', fontWeight: 'bold'}}>
                        {parseFloat(foundTransfer.amount).toLocaleString()} {foundTransfer.currency}
                      </span>
                    </div>
                    <div style={styles.foundRow}>
                      <span style={styles.foundLabel}>التاريخ</span>
                      <span style={styles.foundValue}>{formatDateTime(foundTransfer.created_at)}</span>
                    </div>
                  </div>
                  <div style={{display: 'flex', gap: '10px', marginTop: '15px'}}>
                    <button style={styles.deliverBtn} onClick={deliverTransfer} disabled={loading}>
                      {loading ? 'جاري التسليم...' : '✅ تأكيد التسليم'}
                    </button>
                    <button style={styles.cancelFoundBtn} onClick={() => { setFoundTransfer(null); setSearchCode(''); }}>
                      إلغاء
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* قائمة الحوالات الواردة */}
            <h3 style={{color: '#1a237e', marginBottom: '10px'}}>📋 كل الحوالات الواردة ({incomingTransfers.length})</h3>
            <div style={styles.tableCard}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHead}>
                    <th style={styles.th}>الرقم المرجعي</th>
                    <th style={styles.th}>الكود السري</th>
                    <th style={styles.th}>المستلم</th>
                    <th style={styles.th}>المبلغ</th>
                    <th style={styles.th}>الحالة</th>
                    <th style={styles.th}>التاريخ</th>
                    <th style={styles.th}>تاريخ التسليم</th>
                  </tr>
                </thead>
                <tbody>
                  {incomingTransfers.map((t, i) => (
                    <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                      <td style={{...styles.td, fontSize: '11px', color: '#1a237e', fontWeight: 'bold'}}>{t.reference_number}</td>
                      <td style={styles.td}>
                        <span style={{background: '#fff3e0', color: '#e65100', padding: '4px 10px', borderRadius: '10px', fontSize: '13px', fontWeight: 'bold', letterSpacing: '2px'}}>
                          {t.status === 'pending' ? t.secret_code : '****'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <div style={{fontWeight: 'bold'}}>{t.receiver_name}</div>
                        <div style={{fontSize: '11px', color: '#666'}}>{t.receiver_phone}</div>
                      </td>
                      <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>
                        {parseFloat(t.amount).toLocaleString()} {t.currency}
                      </td>
                      <td style={styles.td}>
                        <span style={{
                          background: t.status === 'completed' ? '#e8f5e9' : t.status === 'pending' ? '#fff3e0' : '#ffebee',
                          color: t.status === 'completed' ? '#2e7d32' : t.status === 'pending' ? '#e65100' : '#c62828',
                          padding: '4px 10px', borderRadius: '20px', fontSize: '11px'
                        }}>
                          {t.status === 'completed' ? '✅ مسلَّمة' : t.status === 'pending' ? '⏳ بانتظار التسليم' : '❌ ملغاة'}
                        </span>
                      </td>
                      <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(t.created_at)}</td>
                      <td style={{...styles.td, fontSize: '11px', color: '#2e7d32'}}>
                        {t.delivered_at ? formatDateTime(t.delivered_at) : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {incomingTransfers.length === 0 && <div style={styles.empty}>لا توجد حوالات واردة</div>}
            </div>
          </div>
        )}

        {/* طلباتي */}
        {activeTab === 'requests' && (
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>📋 كل طلباتي</h2>
              <button style={styles.printBtn2} onClick={handlePrint}>🖨️ طباعة</button>
            </div>
            <div style={styles.tableCard}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHead}>
                    <th style={styles.th}>الرقم المرجعي</th>
                    <th style={styles.th}>النوع</th>
                    <th style={styles.th}>إلى</th>
                    <th style={styles.th}>المبلغ</th>
                    <th style={styles.th}>ملاحظات</th>
                    <th style={styles.th}>الحالة</th>
                    <th style={styles.th}>التاريخ</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((r, i) => {
                    const status = getStatusBadge(r.status);
                    return (
                      <tr key={r.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{r.reference_number}</td>
                        <td style={styles.td}>
                          {r.type === 'pay_to_main' ? <span style={{color: '#2e7d32', fontWeight: 'bold'}}>🏦 تسديد للرئيسي</span> :
                            r.type === 'transfer' ? '💸 تحويل' : '💰 تسديد'}
                        </td>
                        <td style={styles.td}>{r.to_customer_name || 'الرئيسي'}</td>
                        <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{parseFloat(r.amount).toLocaleString()} {r.currency_code}</td>
                        <td style={{...styles.td, fontSize: '11px', color: '#666'}}>{r.notes || '-'}</td>
                        <td style={styles.td}>
                          <span style={{background: status.bg, color: status.color, padding: '3px 8px', borderRadius: '10px', fontSize: '11px'}}>
                            {status.text}
                          </span>
                        </td>
                        <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(r.created_at)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {requests.length === 0 && <div style={styles.empty}>لا توجد طلبات</div>}
            </div>
          </div>
        )}

        {/* كشف الحساب */}
        {activeTab === 'statement' && (
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>📒 كشف الحساب</h2>
              <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <select style={styles.filterSelect} value={filterCurrency} onChange={e => setFilterCurrency(e.target.value)}>
                  <option value="all">كل العملات</option>
                  {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <button style={styles.requestBtn} onClick={fetchStatement}>🔍 بحث</button>
                <button style={styles.printBtn2} onClick={handlePrint}>🖨️ طباعة</button>
              </div>
            </div>

            {statement && (
              <>
                <div style={styles.balanceGrid}>
                  {statement.accounts.map((a, i) => (
                    <div key={i} style={styles.balanceCard}>
                      <div style={styles.balanceCurrency}>{a.currency_code}</div>
                      <div style={{...styles.balanceAmount, color: parseFloat(a.balance) >= 0 ? '#2e7d32' : '#c62828'}}>
                        {parseFloat(a.balance).toLocaleString()}
                      </div>
                      <div style={styles.balanceDetails}>
                        <span style={{color: '#2e7d32'}}>له: {parseFloat(a.total_credit).toLocaleString()}</span>
                        <span style={{color: '#c62828'}}>عليه: {parseFloat(a.total_debit).toLocaleString()}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={styles.tableCard}>
                  <table style={styles.table}>
                    <thead>
                      <tr style={styles.tableHead}>
                        <th style={styles.th}>الرقم المرجعي</th>
                        <th style={styles.th}>نوع العملية</th>
                        <th style={styles.th}>العملة</th>
                        <th style={styles.th}>المبلغ</th>
                        <th style={styles.th}>الرصيد بعد</th>
                        <th style={styles.th}>ملاحظات</th>
                        <th style={styles.th}>التاريخ والوقت</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statement.transactions.map((t, i) => (
                        <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                          <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{t.reference_number}</td>
                          <td style={styles.td}>{getTypeLabel(t.type)}</td>
                          <td style={{...styles.td, fontWeight: 'bold'}}>{t.currency_code}</td>
                          <td style={{...styles.td, fontWeight: 'bold',
                            color: ['receive', 'sell', 'transfer_in'].includes(t.type) ? '#2e7d32' : '#c62828'}}>
                            {['receive', 'sell', 'transfer_in'].includes(t.type) ? '+' : '-'}
                            {parseFloat(t.amount).toLocaleString()}
                          </td>
                          <td style={styles.td}>{parseFloat(t.balance_after || 0).toLocaleString()}</td>
                          <td style={{...styles.td, fontSize: '11px', color: '#666'}}>{t.notes || '-'}</td>
                          <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(t.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {statement.transactions.length === 0 && <div style={styles.empty}>لا توجد عمليات</div>}
                </div>
              </>
            )}
          </div>
        )}

        {/* التقارير */}
        {activeTab === 'reports' && (
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>📊 التقارير</h2>
              {report && (
                <div style={{display: 'flex', gap: '10px'}}>
                  <button style={styles.pdfBtn} onClick={downloadPDF} disabled={loadingPDF}>
                    {loadingPDF ? '⏳...' : '📥 PDF'}
                  </button>
                  <button style={styles.printBtn2} onClick={handlePrint}>🖨️ طباعة</button>
                </div>
              )}
            </div>

            <div style={styles.periodRow}>
              {['daily', 'weekly', 'monthly', 'custom'].map(p => (
                <button key={p}
                  style={reportPeriod === p ? styles.periodActive : styles.periodBtn}
                  onClick={() => setReportPeriod(p)}>
                  {p === 'daily' ? '📅 يومي' : p === 'weekly' ? '📆 أسبوعي' : p === 'monthly' ? '🗓️ شهري' : '📊 مخصص'}
                </button>
              ))}
            </div>

            {reportPeriod === 'custom' && (
              <div style={styles.dateRow}>
                <div>
                  <label style={styles.filterLabel}>من تاريخ</label>
                  <input style={styles.dateInput} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                </div>
                <div>
                  <label style={styles.filterLabel}>إلى تاريخ</label>
                  <input style={styles.dateInput} type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
                </div>
              </div>
            )}

            <button style={styles.fetchBtn} onClick={fetchReport}>🔍 إنشاء التقرير</button>

            {report && (
              <>
                <div style={styles.clientInfoCard}>
                  <h3 style={styles.clientInfoName}>
                    {report.customer?.customer_type === 'company' ? '🏢' : '👤'} {report.customer?.name}
                  </h3>
                  <p style={{color: '#666', fontSize: '12px'}}>
                    {reportPeriod === 'daily' ? 'يومي' : reportPeriod === 'weekly' ? 'أسبوعي' : reportPeriod === 'monthly' ? 'شهري' : `${fromDate} - ${toDate}`}
                  </p>
                </div>

                <div style={styles.balanceGrid}>
                  {report.accounts.map((a, i) => (
                    <div key={i} style={styles.balanceCard}>
                      <div style={styles.balanceCurrency}>{a.currency_code}</div>
                      <div style={{...styles.balanceAmount, color: parseFloat(a.balance) >= 0 ? '#2e7d32' : '#c62828'}}>
                        {parseFloat(a.balance).toLocaleString()}
                      </div>
                      <div style={styles.balanceDetails}>
                        <span style={{color: '#2e7d32'}}>له: {parseFloat(a.total_credit).toLocaleString()}</span>
                        <span style={{color: '#c62828'}}>عليه: {parseFloat(a.total_debit).toLocaleString()}</span>
                      </div>
                    </div>
                  ))}
                </div>

                <div style={styles.tableCard}>
                  <table style={styles.table}>
                    <thead>
                      <tr style={styles.tableHead}>
                        <th style={styles.th}>الرقم المرجعي</th>
                        <th style={styles.th}>نوع العملية</th>
                        <th style={styles.th}>العملة</th>
                        <th style={styles.th}>المبلغ</th>
                        <th style={styles.th}>الرصيد بعد</th>
                        <th style={styles.th}>التاريخ والوقت</th>
                      </tr>
                    </thead>
                    <tbody>
                      {report.transactions.map((t, i) => (
                        <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                          <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{t.reference_number}</td>
                          <td style={styles.td}>{getTypeLabel(t.type)}</td>
                          <td style={{...styles.td, fontWeight: 'bold'}}>{t.currency_code}</td>
                          <td style={{...styles.td, fontWeight: 'bold',
                            color: ['receive','sell','transfer_in'].includes(t.type) ? '#2e7d32' : '#c62828'}}>
                            {['receive','sell','transfer_in'].includes(t.type) ? '+' : '-'}
                            {parseFloat(t.amount).toLocaleString()}
                          </td>
                          <td style={styles.td}>{parseFloat(t.balance_after || 0).toLocaleString()}</td>
                          <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(t.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {report.transactions.length === 0 && <div style={styles.empty}>لا توجد عمليات في هذه الفترة</div>}
                </div>
              </>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  navInfo: { display: 'flex', gap: '15px', alignItems: 'center' },
  navUser: { background: 'rgba(255,255,255,0.2)', color: 'white', padding: '6px 14px', borderRadius: '20px', fontSize: '14px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  printBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  printBtn2: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  pdfBtn: { background: 'linear-gradient(135deg, #c62828, #b71c1c)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  content: { padding: '30px', maxWidth: '1200px', margin: '0 auto' },
  tabs: { display: 'flex', gap: '8px', marginBottom: '25px', flexWrap: 'wrap' },
  tabBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', color: '#666' },
  tabActive: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  section: { marginBottom: '25px' },
  sectionHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' },
  sectionTitle: { color: '#1a237e', fontSize: '18px', marginBottom: '15px' },
  actionButtons: { display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' },
  transferBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  payMainBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  balanceGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '15px', marginBottom: '20px' },
  balanceCard: { background: 'white', borderRadius: '12px', padding: '20px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', borderTop: '4px solid #1a237e' },
  balanceCurrency: { fontSize: '20px', fontWeight: 'bold', color: '#1a237e', marginBottom: '8px' },
  balanceAmount: { fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' },
  balanceDetails: { display: 'flex', justifyContent: 'space-between', fontSize: '11px' },
  noBalance: { background: 'white', borderRadius: '12px', padding: '30px', textAlign: 'center', color: '#999', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  debtGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' },
  debtCard: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', borderRight: '4px solid #c62828' },
  debtType: { fontSize: '13px', color: '#666', marginBottom: '8px' },
  debtAmount: { fontSize: '22px', fontWeight: 'bold', color: '#c62828' },
  debtCurrency: { fontSize: '14px', marginRight: '5px' },
  debtNotes: { fontSize: '11px', color: '#999', marginTop: '5px' },
  summaryCard: { background: 'white', borderRadius: '12px', padding: '20px', display: 'flex', gap: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px', flexWrap: 'wrap' },
  summaryItem: { flex: 1, textAlign: 'center', padding: '10px' },
  summaryLabel: { display: 'block', fontSize: '13px', color: '#666', marginBottom: '8px' },
  summaryValue: { fontSize: '24px', fontWeight: 'bold' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '15px' },
  formTitle: { color: '#1a237e', marginBottom: '10px' },
  formNote: { color: '#e65100', fontSize: '13px', marginBottom: '20px', background: '#fff3e0', padding: '10px', borderRadius: '8px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: {},
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl', boxSizing: 'border-box' },
  availableBalance: { background: '#e3f2fd', padding: '10px', borderRadius: '8px', fontSize: '13px', color: '#1a237e' },
  submitBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  requestBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  filterSelect: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterLabel: { display: 'block', fontSize: '12px', color: '#666', marginBottom: '4px', fontWeight: 'bold' },
  periodRow: { display: 'flex', gap: '8px', marginBottom: '15px', flexWrap: 'wrap' },
  periodBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  periodActive: { background: '#1a237e', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  dateRow: { display: 'flex', gap: '15px', marginBottom: '15px', flexWrap: 'wrap' },
  dateInput: { padding: '8px 12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px' },
  fetchBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '10px 25px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', marginBottom: '20px' },
  clientInfoCard: { background: '#e3f2fd', borderRadius: '12px', padding: '15px 20px', marginBottom: '20px' },
  clientInfoName: { color: '#1a237e', fontSize: '18px', marginBottom: '5px' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'auto', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '10px 12px', color: 'white', textAlign: 'right', fontSize: '12px', whiteSpace: 'nowrap' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '8px 12px', fontSize: '12px', borderBottom: '1px solid #f0f0f0' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
  searchTransferCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', borderTop: '4px solid #1a237e' },
  searchTransferTitle: { color: '#1a237e', marginBottom: '10px' },
  searchTransferRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  searchCodeBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', whiteSpace: 'nowrap' },
  foundTransferCard: { background: '#e8f5e9', borderRadius: '12px', padding: '20px', border: '2px solid #2e7d32' },
  foundTransferDetails: { marginBottom: '10px' },
  foundRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(0,0,0,0.1)' },
  foundLabel: { color: '#666', fontSize: '13px' },
  foundValue: { color: '#1a237e', fontWeight: 'bold', fontSize: '13px' },
  deliverBtn: { flex: 1, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  cancelFoundBtn: { flex: 1, background: '#f5f5f5', color: '#666', border: '1px solid #e0e0e0', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
};

export default ClientDashboard;